import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxEditorModule } from 'ngx-editor';
import { Editor } from 'ngx-editor';

@Component({
  selector: 'hyperkit-editor',
  standalone: true,
  imports: [FormsModule, NgxEditorModule],
  templateUrl: './editor.component.html',
  styleUrl: './editor.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class EditorComponent implements OnInit, OnDestroy, OnChanges {
  @Input() value: string = ''; 
  @Output() valueChange = new EventEmitter<string>();
  editor!: Editor;
  html = '';

  ngOnInit(): void {
    this.editor = new Editor();
    this.html = this.value; 
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.html = this.value;
    }
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  // Emit changes when the editor content is updated
  onEditorChange(value: string): void {
    this.valueChange.emit(value);
  }
}
